import React, { useCallback } from 'react';
import styled from 'styled-components';
import ModalWrapper from '@components/wrapper/Modal/ModalWrapper';
import Button from '@components/dataEntry/button/Button';
import { useRecoilState } from 'recoil';
import { alertModalState } from '@atom/modal/alertModal';
import { AnimatePresence } from 'framer-motion';
import { replaceContents } from '@utils/replaceContents';

const Container = styled.div`
  padding: 40px;
`;

const ButtonWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 8px;
`;

const ModalTitle = styled.h4`
  margin-bottom: 20px;
  word-break: keep-all;
  line-height: 1.3;
  font-weight: 700;
`;

const ModalContent = styled.p`
  word-break: keep-all;
  margin-bottom: 20px;
`;

export interface IAlertModalContents {
  open: boolean;
  title: string;
  content: string;
  confirmBtnValue: string;
  handleConfirmClick: () => void;
}

type AlertModal = {
  closeModal: () => void;
  innerContents: IAlertModalContents;
};

function AlertModal() {
  const [alertModal, setAlertModal] = useRecoilState(alertModalState);
  const { open, title, content, confirmBtnValue, handleConfirmClick } =
    alertModal;

  function closeModal() {
    setAlertModal({ ...alertModal, open: false });
  }

  const handleClick = useCallback(() => {
    handleConfirmClick();
    closeModal();
  }, [handleConfirmClick, alertModal]);

  return (
    <AnimatePresence>
      {open && (
        <ModalWrapper
          outsideClick={closeModal}
          contentStyle={{ maxWidth: 500 }}
        >
          <Container>
            <ModalTitle
              dangerouslySetInnerHTML={{
                __html: replaceContents(title),
              }}
            />
            <ModalContent
              dangerouslySetInnerHTML={{
                __html: replaceContents(content),
              }}
            />
            <ButtonWrap>
              <Button shape="stroke" onClick={closeModal}>
                닫기
              </Button>
              <Button onClick={handleClick}>{confirmBtnValue}</Button>
            </ButtonWrap>
          </Container>
        </ModalWrapper>
      )}
    </AnimatePresence>
  );
}

export default AlertModal;
